<template>
  <Menu
    :key="normalizedValue"
    :class="showPopover ? 'cursor-pointer full-height' : ''"
    :disabled="!showPopover"
    :overflow-padding="16"
    :placement="placement"
    auto-boundary-max-size
    instant-move
  >
    <span :class="showPopover ? 'flex no-wrap items-center full-height' : ''">
      {{ truncatedValue }}

      <span v-if="showPopover"> ... </span>
    </span>

    <template #popper>
      <span class="text-caption">
        {{ normalizedValue }}
      </span>
    </template>
  </Menu>
</template>

<script setup>
import { Menu } from "floating-vue";

import "floating-vue/dist/style.css";

const props = defineProps({
  value: {
    type: [String, Number, Array],
    default: "",
  },

  maxLength: {
    type: Number,
    default: 20,
  },

  placement: {
    type: String,
    default: "right",
  },
});

const normalizedValue = computed(() => {
  if (Array.isArray(props.value)) {
    return props.value.filter(Boolean).join(", ");
  }

  if (props.value === null || props.value === undefined) {
    return "";
  }

  return String(props.value);
});

const truncatedValue = computed(() => {
  return normalizedValue.value.slice(0, props.maxLength);
});

const showPopover = computed(() => {
  return normalizedValue.value.length > props.maxLength;
});
</script>

<style lang="scss" scoped>
:global(.v-popper--theme-dropdown .v-popper__inner) {
  background: white;
  border: none;
  border-radius: 4px;
  box-shadow: $elevation-3;
  color: $neutral;
  font-size: 0.75rem;
  padding: 0.75rem;
  max-width: 320px;
  word-break: break-word;
}

:global(.v-popper--theme-dropdown .v-popper__arrow-outer) {
  border: none;
  box-shadow: $elevation-3;
}
</style>
